const EmbedQueryKeys = {
  global: ["embed"] as const,
  url: (url: string) => [...EmbedQueryKeys.global, url] as const,
};

export { EmbedQueryKeys };
